@if (visible) {
  <div data-testid="complete-profile-prompt"
    class="alert alert-info mb-4 flex items-center justify-between flex-wrap gap-3"
    role="status" aria-live="polite">
    <div class="flex items-center gap-3 min-w-0">
      <app-icon name="assignment_ind" class="flex-shrink-0"></app-icon>
      <!--
        KAN-562 follow-up: this used to read "Your organization has asked you
        to complete your profile." - a polite request, next to a "Don't show
        again" button. Since the course gate shipped, the same unfilled fields
        hard-block every course, so the soft wording actively taught learners
        to ignore the thing that will later lock them out. Same story as the
        gate banner now.
      -->
      <span>
        Your organization requires a few profile details. A course will not
        open until you fill them in.
      </span>
    </div>
    <div class="flex items-center gap-2 flex-shrink-0">
      <a data-testid="complete-profile-prompt-link"
        routerLink="/profile" fragment="profile-fields"
        class="btn btn-primary btn-sm">Complete profile</a>
      <button data-testid="complete-profile-prompt-never"
        class="btn btn-ghost btn-sm"
        (click)="dismissPermanently()">Don't show again</button>
      <button data-testid="complete-profile-prompt-close"
        class="btn btn-ghost btn-sm btn-circle"
        aria-label="Dismiss"
        (click)="dismissForSession()">
        <app-icon name="close"></app-icon>
      </button>
    </div>
  </div>
}
